import { requestPOST, requestDELETE, OLD_API_URL } from '../../../../assets/js/common-es6';

const setNewFavorite = (clientID = '', centerID = 0, callback) => {
  const reqData = {
    clientID,
    centerID,
  };

  requestPOST(`${OLD_API_URL}/offline/favorite`, reqData, (status, resData) => {
    callback(status, resData.data);
  });
};

const setDelFavorite = (favoriteID = 0, callback) => {
  requestDELETE(`${OLD_API_URL}/offline/favorite/${favoriteID}`, {}, (status, resData) => {
    callback(status, resData.data);
  });
};

// setNewFavorite('testkyc', 13);
// setDelFavorite(10);

const shareOnFacebook = (centerID = 0) => {
  window.open(`https://trots.co.kr/?id=${centerID}`);
};

const shareOnKakao = (/* centerID = 0 */) => {
  Kakao.init('dc8e8076aadd8e1484c3a404e98d63c7');

  Kakao.Link.sendCustom({
    templateId: 11353,
  });
};

// shareOnFacebook(99);
// shareOnKakao(99);

export {
  setNewFavorite, setDelFavorite, shareOnFacebook, shareOnKakao,
};
